export default "__VITE_PUBLIC_ASSET__0befb287__"